import ViewFilesHome from "../views/ViewFilesHome.vue"

export default [
	{
		path: "/files",
		component: ViewFilesHome,
		name: "ViewFilesHome",
		meta: {}
	}
]
